module.exports = __webpack_public_path__ + "img/g4.3a5e00d5.png";